import { Brain, ClipboardCheck, ShieldCheck, Boxes } from "lucide-react";

const NODES = [
  { id: "think", label: "THINK", cx: 240, cy: 75, icon: Brain },
  { id: "test", label: "TEST", cx: 88.5, cy: 337.5, icon: ClipboardCheck },
  { id: "trust", label: "TRUST", cx: 391.5, cy: 337.5, icon: ShieldCheck },
];

const ARCS = [
  "M282.3 159.4 A100 100 0 0 1 339.6 258.7",
  "M297.4 331.9 A100 100 0 0 1 182.6 331.9",
  "M140.4 258.7 A100 100 0 0 1 197.7 159.4",
];

export default function TrinityMotif({ className = "" }) {
  return (
    <svg viewBox="0 0 480 420" className={className} role="img" aria-label="Trinity model: Think, Test, Trust"
      data-testid="trinity-motif">
      <defs>
        <radialGradient id="coreGrad" cx="50%" cy="45%" r="60%">
          <stop offset="0%" stopColor="#F4F0FF" />
          <stop offset="60%" stopColor="#CFC2F8" />
          <stop offset="100%" stopColor="#9B84EE" />
        </radialGradient>
        <linearGradient id="nodeGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3B2C93" />
          <stop offset="100%" stopColor="#1B1454" />
        </linearGradient>
        <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="14" />
        </filter>
        <filter id="innerShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#3A2DB8" floodOpacity="0.25" />
        </filter>
        <marker id="arrowHead" markerWidth="9" markerHeight="9" refX="5" refY="4.5" orient="auto">
          <path d="M0,0 L9,4.5 L0,9 z" fill="#FF6B3D" />
        </marker>
      </defs>

      {/* connector triangle */}
      <polygon points="240,75 88.5,337.5 391.5,337.5" fill="#F1EDFB" stroke="#E4DCF9"
        strokeWidth="96" strokeLinejoin="round" filter="url(#innerShadow)" />
      <polygon points="240,75 88.5,337.5 391.5,337.5" fill="none" stroke="#FFFFFF"
        strokeWidth="80" strokeLinejoin="round" opacity="0.9" />

      {/* core */}
      <circle cx="240" cy="250" r="92" fill="#7C3AED" opacity="0.35" filter="url(#softGlow)" className="pulse-glow" />
      <circle cx="240" cy="250" r="76" fill="#FFFFFF" stroke="#D6CCF7" strokeWidth="6" />
      <circle cx="240" cy="250" r="62" fill="url(#coreGrad)" />
      <Boxes x={210} y={220} width={60} height={60} color="#2A1E9E" strokeWidth={1.6} />

      {/* rotating arrows */}
      <g className="spin-slow" style={{ transformOrigin: "240px 250px" }}>
        {ARCS.map((d) => (
          <path key={d} d={d} fill="none" stroke="#FF6B3D" strokeWidth="3.5" strokeLinecap="round" markerEnd="url(#arrowHead)" />
        ))}
      </g>

      {/* nodes */}
      {NODES.map(({ id, label, cx, cy, icon: Icon }) => (
        <g key={id} data-testid={`trinity-node-${id}`}>
          <circle cx={cx} cy={cy} r="70" fill="#7C3AED" opacity="0.35" filter="url(#softGlow)" />
          <circle cx={cx} cy={cy} r="58" fill="url(#nodeGrad)" stroke="#FFFFFF" strokeWidth="5" />
          <Icon x={cx - 16} y={cy - 40} width={32} height={32} color="#E9E2FF" strokeWidth={1.8} />
          <text x={cx} y={cy + 24} textAnchor="middle" fontSize="19" className="neon-node-text">{label}</text>
          <path d={`M${cx - 20} ${cy + 36} Q${cx} ${cy + 44} ${cx + 20} ${cy + 36}`} fill="none" stroke="#FF6B3D" strokeWidth="2.5" strokeLinecap="round" />
        </g>
      ))}
    </svg>
  );
}
